import { Col, Row } from "react-bootstrap";
import { boroNameByCode } from "../../utils/boros/boros";
import { buildingCodeNameByCode } from "../../utils/buildingCode/buildingCode";
import Loading from "../Infrastructure/Loading";
import SearchNav from "./SearchNav";
import {
  DTOResultSBLookup,
  DTOResultTaxAssessemnet,
  DTOSBLookup,
} from "../../Services/Serverless/Lookup/SBL/SBL.interface";
import { useAppDispatch } from "../../Redux/hooks";
import {
  updatePropertyAssessemnet,
  updatePropertyDobNow,
} from "../../Redux/Reducers/propertySlice";
import { Link, useNavigate } from "react-router";
import { callDobBinLookup } from "../../Services/Serverless/callDobBinLookup";
import { useEffect, useState } from "react";
import { useUpdateBookmarksMutation } from "../../Redux/Services/bookmarkApi";
import { QueueMethods } from "../../Services/Serverless/Queue/Queue.interface";
import pollingQueue from "../../Services/Serverless/pollingQueue";

export default function Candidates({
  boro,
  houseNo,
  streetName,
  aptNo,
  token,
}: {
  boro: string;
  houseNo: string;
  streetName: string;
  aptNo: string;
  token: string;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [updateBookmark] = useUpdateBookmarksMutation();
  const [searchingDobin, setSearchingDobin] = useState(false);

  // Start Polling Queue
  const [data, setData] = useState<DTOResultSBLookup | undefined>(undefined);
  useEffect(() => {
    const method = QueueMethods.SBL;
    const inputData = {
      boro,
      houseNo,
      streetName,
      aptNo,
    };
    const intervalHandle = pollingQueue<DTOSBLookup, DTOResultSBLookup>({
      method,
      input: inputData,
      setData,
    });
    return () => {
      if (intervalHandle) clearInterval(intervalHandle);
    };
  }, []);
  // End Polling Queue

  const findDobBinAndNavigate = async (
    selectedProperty: DTOResultTaxAssessemnet,
  ) => {
    setSearchingDobin(true);
    dispatch(updatePropertyAssessemnet(selectedProperty));
    callDobBinLookup({
      boro: selectedProperty.boro,
      houseNo: selectedProperty.housenum_lo,
      streetName: selectedProperty.street_name,
      alt: {
        boro,
        houseNo,
        streetName,
      },
    }).then((dobinRes) => {
      dispatch(updatePropertyDobNow(dobinRes.data));
      updateBookmark({
        data: {
          boro: selectedProperty.boro,
          houseNo: dobinRes.data.HouseNo,
          streetName: dobinRes.data.StreetName,
          aptNo: selectedProperty.aptno,
          block: selectedProperty.block,
          lot: selectedProperty.lot,
          bin: dobinRes.data.BIN,
        },
        token,
      });
      navigate("/property-search/results");
    });
  };
  const handleSelectClick = (selectedProperty: DTOResultTaxAssessemnet) => {
    findDobBinAndNavigate(selectedProperty);
  };

  /*
  useEffect(() => {
    if (data && data.data.length === 1) {
      findDobBinAndNavigate(data.data[0]);
    }
  }, [data?.data]);
  */

  if (searchingDobin) return <Loading message="Looking up DoB Bin" />;
  if (!data) return <Loading message="Search for Block and Lot" />;
  // console.log(data);
  return (
    <div className="candidates">
      {data.data.length === 0 ? (
        <NoCandidate />
      ) : (
        <>
          <SearchNav />
          <div className="candidates-content">
            <table>
              <thead>
                <tr>
                  <th>Owner</th>
                  <th>Building Class</th>
                  <th>Boro / Block / Lot / E</th>
                  <th>Address</th>
                </tr>
              </thead>
              <tbody>
                {data.data.map((property, i) => (
                  <tr key={i} onClick={() => handleSelectClick(property)}>
                    <td>{property.owner}</td>
                    <td>
                      {buildingCodeNameByCode(property.bldg_class)}
                      <br />
                      <small>
                        {buildingCodeNameByCode(property.bldg_class, true)}
                        {` (${property.bldg_class})`}
                      </small>
                    </td>
                    <td>
                      {boroNameByCode(property.boro)}
                      {" / "}
                      {property.block}
                      {" / "}
                      {property.lot}
                      {property.easement && ` / ${property.easement}`}
                    </td>
                    <td>
                      {property.housenum_lo} {property.street_name}
                      {property.aptno && ` APT ${property.aptno}`}
                    </td>
                    <td className="mobile-only">
                      <Row>
                        <Col xs={12}>
                          <dt>Owner</dt>
                          <dd>{property.owner}</dd>
                        </Col>
                        <Col xs={12}>
                          <dt>Building Class</dt>
                          <dd>
                            {buildingCodeNameByCode(property.bldg_class)}
                            <br />
                            {buildingCodeNameByCode(property.bldg_class, true)}
                            {` (${property.bldg_class})`}
                          </dd>
                        </Col>
                        <Col xs={6}>
                          <dt>Boro / Block / Lot / E</dt>
                          <dd>
                            {" "}
                            {boroNameByCode(property.boro)}
                            {" / "}
                            {property.block}
                            {" / "}
                            {property.lot}
                            {property.easement && ` / ${property.easement}`}
                          </dd>
                        </Col>
                        <Col xs={6}>
                          <dt>Address</dt>
                          <dd>
                            {property.housenum_lo} {property.street_name}
                            {property.aptno && ` APT ${property.aptno}`}
                          </dd>
                        </Col>
                      </Row>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

function NoCandidate() {
  return (
    <div className="no-candidate">
      <Row>
        <Col lg={6}>
          <p>Address not found. Try the following:</p>
          <ul>
            <li>Include the dash &quot;-&quot; in the house number</li>
            <li>Spell out street suffix (e.g. Street, Avenue, Court, Lane)</li>
            <li>Use the full street name (e.g. Saint instead of St)</li>
          </ul>
          <p>
            <Link to="/property-search">Back to search</Link>
          </p>
        </Col>
      </Row>
    </div>
  );
}
